class FAQAccordion {
  constructor(section) {
    this.section = section;
    this.faqItems = Array.from(section.querySelectorAll("[data-faq-item]"));

    if (this.faqItems.length === 0) return;

    this.init();
  }

  init() {
    this.faqItems.forEach((item) => {
      const toggle = item.querySelector("[data-faq-toggle]");

      if (toggle) {
        toggle.addEventListener("click", () => this.toggleItem(item));
      }
    });

    // Set proper initial heights
    this.updateHeights();

    // Update heights on window resize
    let resizeTimeout;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        this.updateHeights();
      }, 150);
    });

    // Keyboard navigation
    this.setupKeyboardNavigation();
  }

  toggleItem(item) {
    const isActive = item.classList.contains("active");
    const toggle = item.querySelector("[data-faq-toggle]");
    const answer = item.querySelector("[data-faq-answer]");

    if (isActive) {
      // Close the item
      this.closeItem(item);
    } else {
      // Close all other items if you want accordion behavior (only one open at a time)
      // Comment out the next line if you want multiple items to be open simultaneously
      this.closeAllItems();

      // Open this item
      this.openItem(item);
    }
  }

  openItem(item) {
    const toggle = item.querySelector("[data-faq-toggle]");
    const answer = item.querySelector("[data-faq-answer]");
    const content = answer.querySelector(".faq-answer-content");

    item.classList.add("active");
    toggle.setAttribute("aria-expanded", "true");

    // Set max-height to the content's scroll height
    answer.style.maxHeight = content.scrollHeight + "px";
  }

  closeItem(item) {
    const toggle = item.querySelector("[data-faq-toggle]");
    const answer = item.querySelector("[data-faq-answer]");

    item.classList.remove("active");
    toggle.setAttribute("aria-expanded", "false");
    answer.style.maxHeight = "0";
  }

  closeAllItems() {
    this.faqItems.forEach((item) => {
      if (item.classList.contains("active")) {
        this.closeItem(item);
      }
    });
  }

  updateHeights() {
    this.faqItems.forEach((item) => {
      if (item.classList.contains("active")) {
        const answer = item.querySelector("[data-faq-answer]");
        const content = answer.querySelector(".faq-answer-content");
        answer.style.maxHeight = content.scrollHeight + "px";
      }
    });
  }

  setupKeyboardNavigation() {
    this.faqItems.forEach((item, index) => {
      const toggle = item.querySelector("[data-faq-toggle]");

      if (!toggle) return;

      toggle.addEventListener("keydown", (e) => {
        let targetIndex;

        switch (e.key) {
          case "ArrowDown":
            e.preventDefault();
            targetIndex = (index + 1) % this.faqItems.length;
            this.focusItem(targetIndex);
            break;

          case "ArrowUp":
            e.preventDefault();
            targetIndex =
              (index - 1 + this.faqItems.length) % this.faqItems.length;
            this.focusItem(targetIndex);
            break;

          case "Home":
            e.preventDefault();
            this.focusItem(0);
            break;

          case "End":
            e.preventDefault();
            this.focusItem(this.faqItems.length - 1);
            break;
        }
      });
    });
  }

  focusItem(index) {
    const item = this.faqItems[index];
    const toggle = item?.querySelector("[data-faq-toggle]");

    if (toggle) {
      toggle.focus();
    }
  }
}

// Initialize all FAQ sections on the page
document.addEventListener("DOMContentLoaded", () => {
  const sections = document.querySelectorAll(".faq-section");
  sections.forEach((section) => {
    new FAQAccordion(section);
  });
});

// Reinitialize on section reload (for Shopify theme editor)
if (typeof Shopify !== "undefined" && Shopify.designMode) {
  document.addEventListener("shopify:section:load", (event) => {
    const section = event.target.querySelector(".faq-section");
    if (section) {
      new FAQAccordion(section);
    }
  });
}
